module.exports = __webpack_public_path__ + "img/accuLogo.a234df4a.png";